import { API_ROOT } from '../../config/config'
import { doGet, doPost, doDownload, doPostFiles, doDelete, doPut, doPutFiles } from './utils'

// const API_ROOT = 'http://localhost:9014/api'

const API_ROOT_VER = `${API_ROOT}/v1/accounting/asset-request`

export const getAssetRequestManagementApprove = (pageNumber = 0, pageSize = 0) => {
  const url = `${API_ROOT_VER}/request/manage-request-list/schema/${pageNumber}/${pageSize}`
  return doGet(url)
}
